"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "AuthInterceptor", {
  enumerable: true,
  get: function get() {
    return _auth.default;
  }
});
_Object$defineProperty(exports, "Batcher", {
  enumerable: true,
  get: function get() {
    return _batcher.default;
  }
});
_Object$defineProperty(exports, "Credentials", {
  enumerable: true,
  get: function get() {
    return _credentials.Credentials;
  }
});
_Object$defineProperty(exports, "DefaultOptionsInterceptor", {
  enumerable: true,
  get: function get() {
    return _defaultOptions.default;
  }
});
_Object$defineProperty(exports, "EmbargoInterceptor", {
  enumerable: true,
  get: function get() {
    return _embargo.default;
  }
});
_Object$defineProperty(exports, "MemoryStoreAdapter", {
  enumerable: true,
  get: function get() {
    return _storage.MemoryStoreAdapter;
  }
});
_Object$defineProperty(exports, "NetworkTimingInterceptor", {
  enumerable: true,
  get: function get() {
    return _networkTiming.default;
  }
});
_Object$defineProperty(exports, "NotFoundError", {
  enumerable: true,
  get: function get() {
    return _storage.NotFoundError;
  }
});
_Object$defineProperty(exports, "Page", {
  enumerable: true,
  get: function get() {
    return _page.default;
  }
});
_Object$defineProperty(exports, "PayloadTransformerInterceptor", {
  enumerable: true,
  get: function get() {
    return _payloadTransformer.default;
  }
});
_Object$defineProperty(exports, "RateLimitInterceptor", {
  enumerable: true,
  get: function get() {
    return _rateLimit.default;
  }
});
_Object$defineProperty(exports, "RedirectInterceptor", {
  enumerable: true,
  get: function get() {
    return _redirect.default;
  }
});
_Object$defineProperty(exports, "RequestEventInterceptor", {
  enumerable: true,
  get: function get() {
    return _requestEvent.default;
  }
});
_Object$defineProperty(exports, "RequestLoggerInterceptor", {
  enumerable: true,
  get: function get() {
    return _requestLogger.default;
  }
});
_Object$defineProperty(exports, "RequestTimingInterceptor", {
  enumerable: true,
  get: function get() {
    return _requestTiming.default;
  }
});
_Object$defineProperty(exports, "ResponseLoggerInterceptor", {
  enumerable: true,
  get: function get() {
    return _responseLogger.default;
  }
});
_Object$defineProperty(exports, "ServerErrorInterceptor", {
  enumerable: true,
  get: function get() {
    return _services.ServerErrorInterceptor;
  }
});
_Object$defineProperty(exports, "ServiceCatalog", {
  enumerable: true,
  get: function get() {
    return _services.ServiceCatalog;
  }
});
_Object$defineProperty(exports, "ServiceHost", {
  enumerable: true,
  get: function get() {
    return _services.ServiceHost;
  }
});
_Object$defineProperty(exports, "ServiceInterceptor", {
  enumerable: true,
  get: function get() {
    return _services.ServiceInterceptor;
  }
});
_Object$defineProperty(exports, "ServiceRegistry", {
  enumerable: true,
  get: function get() {
    return _services.ServiceRegistry;
  }
});
_Object$defineProperty(exports, "ServiceState", {
  enumerable: true,
  get: function get() {
    return _services.ServiceState;
  }
});
_Object$defineProperty(exports, "ServiceUrl", {
  enumerable: true,
  get: function get() {
    return _services.ServiceUrl;
  }
});
_Object$defineProperty(exports, "Services", {
  enumerable: true,
  get: function get() {
    return _services.Services;
  }
});
_Object$defineProperty(exports, "StatelessWebexPlugin", {
  enumerable: true,
  get: function get() {
    return _statelessWebexPlugin.default;
  }
});
_Object$defineProperty(exports, "StorageError", {
  enumerable: true,
  get: function get() {
    return _storage.StorageError;
  }
});
_Object$defineProperty(exports, "Token", {
  enumerable: true,
  get: function get() {
    return _credentials.Token;
  }
});
_Object$defineProperty(exports, "UserAgentInterceptor", {
  enumerable: true,
  get: function get() {
    return _userAgent.default;
  }
});
_Object$defineProperty(exports, "WebexHttpError", {
  enumerable: true,
  get: function get() {
    return _webexHttpError.default;
  }
});
_Object$defineProperty(exports, "WebexPlugin", {
  enumerable: true,
  get: function get() {
    return _webexPlugin.default;
  }
});
_Object$defineProperty(exports, "WebexTrackingIdInterceptor", {
  enumerable: true,
  get: function get() {
    return _webexTrackingId.default;
  }
});
_Object$defineProperty(exports, "WebexUserAgentInterceptor", {
  enumerable: true,
  get: function get() {
    return _webexUserAgent.default;
  }
});
_Object$defineProperty(exports, "config", {
  enumerable: true,
  get: function get() {
    return _config.default;
  }
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _webexCore.default;
  }
});
_Object$defineProperty(exports, "filterScope", {
  enumerable: true,
  get: function get() {
    return _credentials.filterScope;
  }
});
_Object$defineProperty(exports, "grantErrors", {
  enumerable: true,
  get: function get() {
    return _credentials.grantErrors;
  }
});
_Object$defineProperty(exports, "makeWebexPluginStore", {
  enumerable: true,
  get: function get() {
    return _storage.makeWebexPluginStore;
  }
});
_Object$defineProperty(exports, "makeWebexStore", {
  enumerable: true,
  get: function get() {
    return _storage.makeWebexStore;
  }
});
_Object$defineProperty(exports, "persist", {
  enumerable: true,
  get: function get() {
    return _storage.persist;
  }
});
_Object$defineProperty(exports, "registerInternalPlugin", {
  enumerable: true,
  get: function get() {
    return _webexCore.registerInternalPlugin;
  }
});
_Object$defineProperty(exports, "registerPlugin", {
  enumerable: true,
  get: function get() {
    return _webexCore.registerPlugin;
  }
});
_Object$defineProperty(exports, "serviceConstants", {
  enumerable: true,
  get: function get() {
    return _services.constants;
  }
});
_Object$defineProperty(exports, "sortScope", {
  enumerable: true,
  get: function get() {
    return _credentials.sortScope;
  }
});
_Object$defineProperty(exports, "waitForValue", {
  enumerable: true,
  get: function get() {
    return _storage.waitForValue;
  }
});
require("./plugins/logger");
var _credentials = require("./lib/credentials");
var _services = require("./lib/services");
var _storage = require("./lib/storage");
var _webexCore = _interopRequireWildcard(require("./webex-core"));
var _webexHttpError = _interopRequireDefault(require("./lib/webex-http-error"));
var _statelessWebexPlugin = _interopRequireDefault(require("./lib/stateless-webex-plugin"));
var _webexPlugin = _interopRequireDefault(require("./lib/webex-plugin"));
var _auth = _interopRequireDefault(require("./interceptors/auth"));
var _networkTiming = _interopRequireDefault(require("./interceptors/network-timing"));
var _payloadTransformer = _interopRequireDefault(require("./interceptors/payload-transformer"));
var _redirect = _interopRequireDefault(require("./interceptors/redirect"));
var _responseLogger = _interopRequireDefault(require("./interceptors/response-logger"));
var _requestEvent = _interopRequireDefault(require("./interceptors/request-event"));
var _requestLogger = _interopRequireDefault(require("./interceptors/request-logger"));
var _requestTiming = _interopRequireDefault(require("./interceptors/request-timing"));
var _userAgent = _interopRequireDefault(require("./interceptors/user-agent"));
var _webexTrackingId = _interopRequireDefault(require("./interceptors/webex-tracking-id"));
var _webexUserAgent = _interopRequireDefault(require("./interceptors/webex-user-agent"));
var _rateLimit = _interopRequireDefault(require("./interceptors/rate-limit"));
var _embargo = _interopRequireDefault(require("./interceptors/embargo"));
var _defaultOptions = _interopRequireDefault(require("./interceptors/default-options"));
var _batcher = _interopRequireDefault(require("./lib/batcher"));
var _page = _interopRequireDefault(require("./lib/page"));
var _config = _interopRequireDefault(require("./config"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
//# sourceMappingURL=index.js.map
